const React = require('react');

function withFormState({ formName, getInitialState }, Wrapped) {
  class WithFormState extends React.Component {
    constructor(props) {
      super(props);

      this.state = getInitialState(props);
    }

    handleChange = (e, fieldName, value) => {
      if (!fieldName && !value) {
        fieldName = e.target.name;
        value = e.target.value;
      }
      this.setState({
        [fieldName]: value === '' ? null : value,
      });
    };

    render() {
      return (
        <Wrapped
          {...this.props}
          {...{
            [formName]: {
              values: this.state,
              onChange: this.handleChange,
            },
          }}
        />
      );
    }
  }

  return WithFormState;
}

export default withFormState;
